/** Consultant id from a slot coordinate "YYYY-MM-DD|HH:MM:SS|consultantId". */
export function consultantIdFromCoord(coord: string): number | null {
  const id = Number(coord.split("|")[2]);
  return Number.isInteger(id) && id > 0 ? id : null;
}

/**
 * Managers lock/unlock any slot. Consultants with the schedule update permission
 * can lock/unlock only their own slots (asked for the mobile agenda).
 */
export function canChangeSlotLock(params: {
  selection: string[];
  canManageSchedules: boolean;
  canEditOwnSlots: boolean;
  viewerId?: number | null;
}): boolean {
  const { selection, canManageSchedules, canEditOwnSlots, viewerId } = params;
  if (canManageSchedules) {
    return true;
  }
  if (!canEditOwnSlots || viewerId == null || selection.length === 0) {
    return false;
  }
  return selection.every((coord) => consultantIdFromCoord(coord) === viewerId);
}
